import script from "./tasks-view-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./tasks-view-modal.vue?vue&type=script&setup=true&lang=js"

import "./tasks-view-modal.vue?vue&type=style&index=0&id=7ca6e5e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca6e5e2"]])

export default __exports__